import React from "react";
import { Box, Grid } from "@mui/material";
import { usePlatform } from "../platform/store";
import { PageRoot, RecordCard, SectionCard, SummaryGrid } from "./ui/PlatformPrimitives";

const ComplianceAutomationHub = () => {
  const { jobs } = usePlatform();

  return (
    // Disabled/preview state — drop overall opacity so glass surfaces still
    // refract the page gradient but read as semantically lower-contrast.
    <Box sx={{ opacity: 0.6 }}>
      <PageRoot>
        <SummaryGrid
          items={[
            ["Jobs", jobs.length],
            ["Running", jobs.filter((job) => job.status === "Running").length],
            ["Queued", jobs.filter((job) => job.status === "Queued").length],
            ["Completed", jobs.filter((job) => job.status === "Completed").length],
          ]}
        />

        <SectionCard eyebrow="Queue" title="Automation jobs">
          <Grid container spacing={2}>
            {jobs.map((job) => (
              <Grid key={job.id} size={{ xs: 12, md: 6 }}>
                <RecordCard
                  title={job.name}
                  subtitle={`${job.owner} • ${new Date(job.updatedAt).toLocaleString()}`}
                  status={job.status}
                  chips={[job.type]}
                />
              </Grid>
            ))}
          </Grid>
        </SectionCard>
      </PageRoot>
    </Box>
  );
};

export default ComplianceAutomationHub;
